import React, { useState } from 'react';
import { useAppSelector } from '../../hooks/useRedux';
import { ITutorDetailsStatus } from '@wot/typings';

function HorizontalStepper() {
  const [currentStep, setCurrentStep] = useState(0);
  const { request } = useAppSelector((state) => state.profileSetupSlice);
  return (
    <div>
      <div className="flex flex-col lg:flex-row relative z-20">
        <div className="lg:flex mt-3 w-5/6 hidden absolute -z-10 border-t border-neutralGray2 border-dashed"></div>
        <div className="lg:hidden mt-3 h-5/6 absolute left-3 -z-10 border border-neutralGray2 border-dashed"></div>
        <Item
          title="Personal Details"
          text="Please enter your personal details and upload ID for verification."
          status={request?.personal?.status || ''}
          stepNo={1}
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
        />
        <Item
          title="Education Details"
          text="Please enter your education details and upload for verification."
          status={request?.education?.status || ''}
          stepNo={2}
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
        />
        <Item
          title="Experience Details"
          text="Please enter your experience details and upload for verification."
          status={request?.experience?.status || ''}
          stepNo={3}
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
        />
        <Item
          title="Add Subjects"
          text="Please enter your profession details and upload for verification."
          status={request?.profession?.status || ''}
          stepNo={4}
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
        />
        <Item
          title="Availability"
          text="Please add your slots in the calendar to get the bookings from student."
          status={''}
          stepNo={5}
          setCurrentStep={setCurrentStep}
          currentStep={currentStep}
        />
      </div>
    </div>
  );
}

interface ItemProps {
  title: string;
  text: string;
  status: ITutorDetailsStatus | '';
  stepNo: number;
  setCurrentStep: any;
  currentStep: number;
}

function Item({ title, text, status, stepNo, setCurrentStep }: ItemProps) {
  return (
    <div
      key={stepNo}
      className="flex lg:flex-col flex-row justify-start cursor-pointer lg:gap-0 gap-5"
      onClick={() => setCurrentStep(stepNo)}
    >
      <div
        className={`p-1 text-center text-xs w-6 h-6 rounded-full shrink-0
        ${
          status === 'pending'
            ? 'bg-neutralGray1 text-white'
            : status === 'verified'
            ? 'bg-[#34C26D] text-white'
            : status === 'issue'
            ? 'bg-red-400 text-white'
            : 'bg-white text-black border border-black/75'
        }
      `}
      >
        {stepNo}
      </div>
      <div>
        <p className="text-sm font-medium lg:py-2 py-1">{title}</p>
        <p className="text-sm text-neutralGray2 pr-4">{text}</p>
      </div>
    </div>
  );
}

export default HorizontalStepper;
